export const ALL_DIFFICULTIES = [
  'Beginner',
  'Intermediate',
  'Advanced',
  'Social',
  'All Skill Levels',
  'Other'
];

export const ALL_AVAILABILITIES = [
  'Has Waitlist',
  'No waitlist'
];
